<template>
    <div class="main-content container-fluid container-xl">
        <transition name="fade" mode="out-in">
            <router-view />
        </transition>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import './Content.scss';
</style>
